import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, Select, message } from "antd";
import { warehouseService } from "@/views/base/warehouseManage/warehouseService";
import useGlobalModel from "@/model/globalModel";
import { globalPrompt } from "@/components/message";

interface AddShelfModalProps {
    visible: boolean;
    warehouseCode?: string; // 可选的初始仓库编码
    onCancel: () => void;
    onSuccess: (newShelf: any) => void; // 新增成功后的回调
}

export const AddShelfModal = ({ visible, warehouseCode, onCancel, onSuccess }: AddShelfModalProps) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { warehouseList, shopAndOrg } = useGlobalModel();

    // 当仓库变化时清空货位输入
    const handleWarehouseChange = (value: string) => {
        form.setFieldsValue({ shelfCode: '' });
    };

    // 提交新增货位
    const handleSubmit = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();

            // 构造请求参数
            const params = {
                ...shopAndOrg,
                warehouseId: warehouseList.find(w => w.value === values.warehouseCode)?.id,
                code: values.shelfCode,
                warehouseName: warehouseList.find(w => w.value === values.warehouseCode)?.label,
                warehouseCode: values.warehouseCode
            };
            let { retData } = await warehouseService.shelfInsert(params);
            if (retData) {
                globalPrompt("message", { text: "货位新增成功", type: "success" });
                onSuccess({
                    label: values.shelfCode,
                    value: values.shelfCode,
                    ...params
                });
                form.resetFields();
                onCancel();
            } else {
                globalPrompt("message", { text: "货位新增失败", type: "error" });
            }
        } catch (error) {
            console.error('新增货位失败:', error);
        } finally {
            setLoading(false);
        }
    };

    // 组件挂载时设置初始仓库
    useEffect(() => {
        if (warehouseCode) {
            form.setFieldsValue({ warehouseCode });
        }
    }, [warehouseCode, form]);

    return (
        <Modal
            title="新增货位"
            visible={visible}
            onCancel={onCancel}
            maskClosable={false}
            footer={[
                <Button key="cancel" onClick={onCancel}>取消</Button>,
                <Button key="submit" type="primary" loading={loading} onClick={handleSubmit}>
                    确认添加
                </Button>
            ]}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{ warehouseCode }}
            >
                <Form.Item
                    name="warehouseCode"
                    label="仓库"
                    rules={[{ required: true, message: "请选择仓库" }]}
                >
                    <Select
                        style={{ width: '100%' }}
                        options={warehouseList}
                        showSearch
                        disabled
                        filterOption={(input: any, option: any) =>
                            option?.label.toLowerCase().includes(input.toLowerCase())
                        }
                        onChange={handleWarehouseChange}
                    />
                </Form.Item>


                <Form.Item
                    name="shelfCode"
                    label="货位名称"
                    rules={[{ required: true, message: "请输入货位名称" }]}
                >
                    <Input placeholder="请输入货位名称" />
                </Form.Item>
            </Form>
        </Modal>
    );
};
